module.exports = __webpack_public_path__ + "static/caffe-corretto-logo-79b29cba0fd6d99d66eb704d96cc7760.png";